/**
 * Defines the constants used by the Constants module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

export const VUEX_VERSION_INIT			        = 'VUEX_VERSION_INIT'
export const VUEX_VERSION_INITIALIZED		    = 'VUEX_VERSION_INITIALIZED'
export const VUEX_VERSION_SET_VERSION			= 'VUEX_VERSION_SET_VERSION'